import { useTranslation } from 'react-i18next'

import { localizeRosterRefusal } from '../../lib/roster/rosterRefusal'

export default function NoRosterRole({ reason }: { reason?: string | null }) {
  const { t } = useTranslation()
  return (
    <div className="mx-auto max-w-xl p-6">
      <p className="rounded-lg border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-900 dark:border-amber-900 dark:bg-amber-950/30 dark:text-amber-200">
        <span className="font-medium">{t('roster.noRosterRole')}</span>{' '}
        {reason?.trim() ? localizeRosterRefusal(reason, t) : t('roster.noRosterRoleHint')}
      </p>
    </div>
  )
}
